var app = angular.module('directives.counter', []);

    require('./directives/counter.js');
    require('./stylesheets/styles.scss');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/counter/index.js
 ** module id = 152
 ** module chunks = 1
 **/